export default __webpack_public_path__ + "static/media/culture_EP10.16817cea.png";